import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AppSessions from './pages/AppSessions';
import GameSessions from './pages/GameSessions';
import GameLevels from './pages/GameLevels';
import ChatThreads from './pages/ChatThreads';
import TestSessions from './pages/TestSessions';
import Users from './pages/Users';
import OpenedSessions from './pages/OpenedSessions';
import NewUsers from './pages/NewUsers';
import OpenedGames from './pages/OpenedGames';
import OpenedTests from './pages/OpenedTests';
import OpenedChats from './pages/OpenedChats';
import ChatThreadDetail from './pages/ChatThreadDetail';
import ProfileTree from './pages/ProfileTree';
import MetaAnalytics from './pages/MetaAnalytics';
import NotificationCenter from './pages/NotificationCenter';
import RoadMap from './pages/RoadMap';
import Settings from './pages/Settings';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/app-sessions" element={<AppSessions />} />
                    <Route path="/game-sessions" element={<GameSessions />} />
                    <Route path="/game-levels" element={<GameLevels />} />
                    <Route path="/chat-threads" element={<ChatThreads />} />
                    <Route path="/test-sessions" element={<TestSessions />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/opened-sessions" element={<OpenedSessions />} />
                    <Route path="/new-users" element={<NewUsers />} />
                    <Route path="/opened-games" element={<OpenedGames />} />
                    <Route path="/opened-tests" element={<OpenedTests />} />
                    <Route path="/opened-chats" element={<OpenedChats />} />
                    <Route path="/chat-thread/:threadId" element={<ChatThreadDetail />} />
                    <Route path="/profile-tree" element={<ProfileTree />} />
                    <Route path="/meta-analytics" element={<MetaAnalytics />} />
                    <Route path="/notification-center" element={<NotificationCenter />} />
                    <Route path="/road-map" element={<RoadMap />} />
                    <Route path="/settings" element={<Settings />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
